module.exports = __webpack_public_path__ + "assets/betrouwbaar.f3b41b68.svg";